const AmountTile = ({ amount = 0, isActive = false, onClick = () => {} }) => {
  return (
    <div onClick={onClick} className={`focus:outline-none w-26 mx-2 my-2 px-5 py-2 rounded-2xl border ${isActive ? "border-orange" : "border-gray-light"} hover:opacity-75 transition-all cursor-pointer`}>
      <p className={`text-center select-none ${isActive ? "text-orange" : "text-gray"} text-lg uppercase transition-all`}>{amount}</p>
    </div>
  );
};

export default AmountTile;
